export default "__VITE_ASSET__Dmk6NPMu__"